import React from "react";
import { Icon } from "antd";

const home = {
  id: "home",
  title: "首页",
  MenuIcon: <Icon type="dashboard" />,
};

const propertyList = {
  id: "propertyList",
  title: "资产列表",
  MenuIcon: <Icon type="database" />,
  MenuContent: [
    {
      id: "order",
      title: "订单贷资产",
    },
    {
      id: "paying",
      title: "应收账款",
    },
    {
      id: "car",
      title: "融资租赁资产",
    },
    {
      id: "family",
      title: "家装类资产",
    },
  ],
};

const fundList = {
  id: "fundList",
  title: "资金列表",
  MenuIcon: <Icon type="bank" />,
};

const propertySetting = {
  id: "propertySetting",
  title: "资产设置",
  MenuIcon: <Icon type="setting" />,
};

export const allItem = [home, propertyList, fundList, propertySetting];
